// Contract deadline day-counting, shared by the app's forms, the MCP server and the contract reader.
// Holiday list moved here from BuyerForm.jsx (getUSBankHolidays, which blocks weekend/holiday closing dates).
// Rule (FR/BAR and NABOR style): the Effective Date is day 0. Calendar days by default; if the last day
// lands on a Saturday, Sunday or holiday it rolls to the next business day. Business-day mode counts
// only business days. Dates are 'YYYY-MM-DD' strings, handled in local time with no time-of-day.
const pad = (n) => String(n).padStart(2, '0');
const toKey = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
const parseKey = (s) => { const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(s || '')); return m ? new Date(+m[1], +m[2] - 1, +m[3]) : null; };
const nthWeekday = (y, month, weekday, n) => { const first = new Date(y, month, 1).getDay(); return new Date(y, month, 1 + ((weekday - first + 7) % 7) + (n - 1) * 7); };
const lastWeekday = (y, month, weekday) => { const last = new Date(y, month + 1, 0); return new Date(y, month + 1, 0 - ((last.getDay() - weekday + 7) % 7)); };
const cache = {};
// US federal (national legal) holidays, 5 U.S.C. 6103, on their actual dates.
function getUSBankHolidays(year) {
  if (cache[year]) return cache[year];
  const h = new Set(); const add = (d) => h.add(toKey(d));
  add(new Date(year, 0, 1)); add(nthWeekday(year, 0, 1, 3)); add(nthWeekday(year, 1, 1, 3)); add(lastWeekday(year, 4, 1));
  add(new Date(year, 5, 19)); add(new Date(year, 6, 4)); add(nthWeekday(year, 8, 1, 1)); add(nthWeekday(year, 9, 1, 2));
  add(new Date(year, 10, 11)); add(nthWeekday(year, 10, 4, 4)); add(new Date(year, 11, 25));
  cache[year] = h; return h;
}
const isWeekend = (d) => d.getDay() === 0 || d.getDay() === 6;
const isHoliday = (d) => getUSBankHolidays(d.getFullYear()).has(toKey(d));
const isBusinessDay = (d) => !isWeekend(d) && !isHoliday(d);
const nextBusinessDay = (d) => { const x = new Date(d); while (!isBusinessDay(x)) x.setDate(x.getDate() + 1); return x; };
// Returns { date: 'YYYY-MM-DD', rolled: bool, reason } or null when the inputs are not usable.
function deadlineFrom(effectiveDate, days, mode = 'calendar') {
  const start = parseKey(effectiveDate); const n = Number(days);
  if (!start || !Number.isInteger(n) || n < 0 || n > 3650) return null;
  const d = new Date(start);
  if (mode === 'business') {
    let left = n;
    while (left > 0) { d.setDate(d.getDate() + 1); if (isBusinessDay(d)) left -= 1; }
    return { date: toKey(d), rolled: false, reason: '' };
  }
  d.setDate(d.getDate() + n);
  if (n === 0 || isBusinessDay(d)) return { date: toKey(d), rolled: false, reason: '' };
  const reason = isWeekend(d) ? 'weekend' : 'holiday';
  return { date: toKey(nextBusinessDay(d)), rolled: true, reason, landedOn: toKey(d) };
}
// Error text for a date that must be a business day (used by BuyerForm's closing date check).
function businessDayError(dateStr, label = 'Date') {
  const d = parseKey(dateStr); if (!d) return '';
  if (isWeekend(d)) return `${label} cannot be on a weekend. Please pick a business day.`;
  if (isHoliday(d)) return `${label} cannot be on a US bank holiday. Please pick a business day.`;
  return '';
}
module.exports = { getUSBankHolidays, isBusinessDay, nextBusinessDay, deadlineFrom, businessDayError, toDateKey: toKey, parseDateKey: parseKey };
